<template>
  <nav class="navbar navbar-expand-lg ">
  <div class="container-fluid">
   
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
       
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
             البلدان والمدن
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                   
                   <li> <router-link to="/ViewGov" class="dropdown-item dropp" >المحافظات</router-link> </li>
                   <li> <router-link to="/ViewDirectorates" class="dropdown-item dropp" >المديريات</router-link> </li>
                   <li> <router-link to="/CityView" class="dropdown-item dropp" >المدن</router-link> </li>
                   <li> <router-link to="/districtView" class="dropdown-item dropp" >الحي</router-link> </li>
                   <li> <router-link to="/ViewRes" class="dropdown-item dropp" >المربع السكني</router-link> </li>
          
          </ul>
        </li>
      
       
         <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            التحقيقات 
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                   <li> <router-link to="/RecordView" class="dropdown-item dropp " >المحاضر</router-link>    </li>
                   <li> <router-link to="/DetictiveView" class="dropdown-item dropp " >المحققون </router-link>    </li>
          
          </ul>
        </li>

         <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            الشكوى 
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                   <li> <router-link to="/ComplainView" class="dropdown-item dropp " >الشكاوي</router-link>    </li>
          
          </ul>
        </li>

         <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            اضافات 
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                   <li> <router-link to="/NationalityView" class="dropdown-item dropp " >الجنسيات</router-link>    </li>
                   <li> <router-link to="/Marital_StatusView" class="dropdown-item dropp " >الحالة الاجتماعية</router-link>    </li>
                   <li> <router-link to="/Complaint_TypeView" class="dropdown-item dropp " >نوع الشكوى</router-link>    </li>
                   <li> <router-link to="/IdentityView" class="dropdown-item dropp " >الهوية</router-link>    </li>
                   <li> <router-link to="/Education_LevelView" class="dropdown-item dropp " >المستوى التعليمي</router-link>    </li>
                   <li> <router-link to="/Status_TypeView" class="dropdown-item dropp " >الحالة</router-link>    </li>
                   <li> <router-link to="/Complaint_RecipientView" class="dropdown-item dropp " >الظروف</router-link>    </li>
                   <li> <router-link to="/Complaint_ProceduresView" class="dropdown-item dropp " >الاجراءات</router-link>    </li>
          
          </ul>
        </li>
        
      </ul>
     
    </div>
  </div>
</nav>  
</template>

<script>
export default {
name:'NavBarr'
}
</script>

<style>

</style>